import { Sentry } from '@quadralize/sentry'
import { Toaster } from '@quadralize/ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type PropsWithChildren, useEffect } from 'react'
import { useSessionBootstrap } from '@/modules/auth/hooks/use-session-bootstrap'
import { useAppStore } from '@/store/use-app-store'

const STALE_TIME_MS = 300_000

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      retry: 1,
    },
  },
})

export function Providers({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <ThemeSync />
        <SessionBootstrap />
        <Toaster richColors position="top-right" />
        {children}
        {import.meta.env.DEV && (
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        )}
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
}

function SessionBootstrap() {
  useSessionBootstrap()

  return null
}

function ThemeSync() {
  const theme = useAppStore((state) => state.theme)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark')
  }, [theme])

  return null
}
